import { createInertiaApp, router } from '@inertiajs/react'

// Keep the <meta name="csrf-token"> element in sync with the current request's
// authenticity token. Inertia visits update <body> but not <head>, so after
// Devise rotates the session on sign in / sign out the meta tag goes stale.
// ApplicationController publishes form_authenticity_token via inertia_share
// (as csrf_token); this listener writes that fresh value into the meta tag
// on every navigation. @rails/activestorage's DirectUpload reads this tag at
// upload time, so the sync keeps file uploads working post-login.
router.on('navigate', (event) => {
  const token = (event.detail.page.props as Record<string, unknown>).csrf_token
  if (typeof token === 'string') {
    const meta = document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')
    if (meta) meta.content = token
  }
})

void createInertiaApp({
  pages: "../pages",

  strictMode: true,

  defaults: {
    form: {
      forceIndicesArrayFormatInFormData: false,
      withAllErrors: true,
    },
    visitOptions: () => {
      return { queryStringArrayFormat: "brackets" }
    },
  },
}).catch((error) => {
  // This ensures this entrypoint is only loaded on Inertia pages
  // by checking for the presence of the root element (#app by default).
  // Feel free to remove this `catch` if you don't need it.
  if (document.getElementById("app")) {
    throw error
  } else {
    console.error(
      "Missing root element.\n\n" +
      "If you see this error, it probably means you loaded Inertia.js on non-Inertia pages.\n" +
      'Consider moving <%= vite_typescript_tag "inertia.tsx" %> to the Inertia-specific layout instead.',
    )
  }
})
